<template>

	<header id="Header">

		<div id="Top"></div>

		<div id="Breadcrumb">

			<a @click="back">

				<div class="button">

					<div class="button__left">



					</div>

					<div class="button__middle">

						<img class="button__icon" src="../../assets/icons/back.png" alt="Back" />

						{{ $t('back') }}

					</div>

					<div class="button__right">



					</div>

				</div>

			</a>

			<div id="Pages">

				<div class="page" :class="{'page--current': this.$route.name === 'home'}">{{ $t('home') }}</div>


				<div class="page page--current" v-if="this.$route.name === 'metrology'">{{ $t('metrology') }}</div>
				<div class="page page--current" v-if="this.$route.name === 'inspection'">{{ $t('inspection') }}</div>
				<div class="page page--current" v-if="this.$route.name === 'analysis'">{{ $t('analysis') }}</div>
				<div class="page page--current" v-if="this.$route.name === 'applications'">{{ $t('applications') }}</div>
				<div class="page page--current" v-if="this.$route.name === 'x-ray_series'">{{ $t('xraySeries') }}</div>
				<div class="page page--current" v-if="this.$route.name === 'why_x-ray'">{{ $t('whyXray') }}</div>

				<div class="page page" v-if="this.$route.name === 'x-ray_series-systems'">{{ $t('xraySeries') }}</div>
				<div class="page page--current" v-if="this.$route.name === 'x-ray_series-systems'">{{ $t('systems') }}</div>

				<div class="page page" v-if="this.$route.name === 'x-ray_series-software'">{{ $t('xraySeries') }}</div>
				<div class="page page--current" v-if="this.$route.name === 'x-ray_series-software'">{{ $t('software') }}</div>

			</div>

		</div>

		<img id="Logo" src="../../assets/logo.png" alt="Zeiss Logo" />

	</header>

</template>

<script>

	import routes from "../../routes";

	export default {

		methods: {
			back () {
				for (let r of routes) {
					if (this.$route.name === r.name) {
						this.$router.push(r.backPath);
					}
				}
			}
		}

	};

</script>